import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose } from 'class-transformer';

export class GPSStatus extends AdditionalInfoImpl {
  @Expose({ name: 'azymut' })
  azimuth: number;
  latitude: number;
  longitude: number;
  speed: number;
}
